import {SENT_MAIL_ENUM} from "@/constant/constants.ts";
import {useTranslation} from "react-i18next";

const SentMailStatusTag = ({status}: { status?: number | null }) => {
    const {t} = useTranslation();

    let color = '#fafafa';
    if (status === SENT_MAIL_ENUM.NOT_YET) {
        color = '#FF4861'
    } else if (status === SENT_MAIL_ENUM.SENT) {
        color = '#1FD61B'
    }

    const SENT_MAIL_MAP: Map<number, string> = new Map([
        [SENT_MAIL_ENUM.NOT_YET, t('field.notYet')],
        [SENT_MAIL_ENUM.SENT, t('field.sent')],
    ])

    return (<>
        {
            status ?
                <span key={status} className={'w-[88px] text-center whitespace-nowrap'}>
                    <span style={{color: color}}>•</span> {SENT_MAIL_MAP.get(status)}
                </span> :
                <span>-</span>
        }
    </>)
}

export default SentMailStatusTag;